// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1loxU","notes":"Notes_notes__2gI13"};